import './App.css';
import StreamRecords from './Pages/StreamRecord';
import "./style.css"
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Login from './Pages/Login';
import { recordReturnPath } from './authNavigation';

const ProtectedRoute = ({element}) => {
  const location = useLocation()
  const token = localStorage.getItem('stats-insight-login')
  let loginStamp = null
  try {
    loginStamp = JSON.parse(localStorage.getItem('stats-insight-login-info'))
  } catch {
    // Missing or damaged browser state is an expired session, not a render error.
  }
  const isLoginInfo = loginStamp !== null && typeof loginStamp === 'object' && !Array.isArray(loginStamp)
  const expiry = isLoginInfo ? loginStamp.expiredTime : undefined
  // Accept Login ISO dates and legacy numeric expiry values without extending either.
  const validExpiryType = typeof expiry === 'number' || (typeof expiry === 'string' && expiry.trim() !== '')
  const loginTimeStamp = validExpiryType ? new Date(expiry).getTime() : NaN
  const current = new Date()
  if (token === null || !Number.isFinite(loginTimeStamp) || loginTimeStamp <= current.getTime()) {
    localStorage.removeItem('stats-insight-login')
    localStorage.removeItem('stats-insight-login-info')
    return <Navigate to='/login' replace state={{ returnTo: recordReturnPath(location.pathname) }} />
  }
  return element
} 

function App() {
  // The socket is a module-level singleton (src/socket.js) — StreamRecord
  // imports it directly, so it no longer needs to be created or prop-drilled
  // here.
  return (
    <div className="App">
      <Routes>
        <Route path='/intime-record/:mode' element={<ProtectedRoute element={<StreamRecords />} />} />
        <Route path='/intime-record-test/:mode' element={<ProtectedRoute element={<StreamRecords test />} />} />
        <Route path='/intime-record-examine/:mode' element={<ProtectedRoute element={<StreamRecords test checker />} />} />
        <Route path='/login' element={<Login />} />
        <Route path='*' element={<Navigate to='/login' replace />} />
      </Routes>
    </div>
  );
}

export default App;
